export default {
  API: {
    baseURL: "http://127.0.0.1:5000/api"
  }
};
